// TEMPORARY (owner order 2026-10-25): hide the in-app Settings > "Privacy Mode (Coming Soon)" section while payment processors review
// Goonru. Every control in it is unbuilt (it says so itself: "won't change app behavior") and names like "Stealth Mode", "Rotate User Agents"
// and "Disable Screenshots" read badly to a reviewer. Set to true to show it again once the controls are real.
export const SHOW_PRIVACY_MODE = false

// Same reason (owner order 2026-10-26): the "Smart Shuffle (Coming Soon, not implemented yet)" switch in Settings > Browsing.
export const SHOW_SMART_SHUFFLE = false
